<div class="p-grid p-col p-jc-end view-top-actions" *ngIf="personalize_interface">
  <p-overlayPanel #op appendTo="body">
    <ng-template pTemplate>
      <div style="min-width: 300px;" *ngIf="personalize_interface">
        <label><small>¿Qué vista quiere mostrar?</small></label><br />
        <p-dropdown [options]="dropdownViews" [(ngModel)]="selectedView" optionLabel="name" optionValue="id"
          [filter]="true" filterBy="name" class="p-field" *ngIf="personalized_views_read" appendTo="body"
          placeholder="Selecciona una vista" (onChange)="changeCurrentView()">
          <ng-template pTemplate="selectedItem">
            <div class="view-item">
              <div><i class="fa fa-thumbtack p-mr-1"></i> {{view.name}} </div>
            </div>
          </ng-template>
          <ng-template let-view pTemplate="item">
            <!--
        <div *ngIf="view.id != -1"><i class="fa fa-thumbtack p-mr-1" *ngIf="view.id == selectedView"></i>{{view.name}} <span style="font-size: 11px; color: #7b918d" *ngIf="view.metadata?.default == true"> (por defecto)</span> </div>
        <div *ngIf="view.id == -1 && personalized_views_write" class="p-text-center"><p-button label="Añadir nueva vista" icon="pi pi-plus" styleClass="p-ml-2 p-block" (click)="newView(false); event.preventDefault()"></p-button></div>
        -->
            <div style="display:flex;align-items:center;">
              <div style="margin-right: 5px;">
                <i class="fa fa-thumbtack p-mr-1" *ngIf="view.id == selectedView"></i>
              </div>
              <div>
                <div *ngIf="view.id != -1">
                  {{view.name}} <span style="font-size: 11px; color: #7b918d" *ngIf="view.metadata?.default == true">
                    (por defecto)</span>
                </div>
                <div *ngIf="view.id == -1 && personalized_views_write" class="p-text-center">
                  <p-button label="Añadir nueva vista" icon="pi pi-plus" styleClass="p-ml-2 p-block"
                    (click)="newView(false); event.preventDefault()"></p-button>
                </div>
                <div *ngIf="view.id > 0 " style="color: #a1b6b2">
                  <small>
                    {{
                    view.user?.name ? 'Creada por: '+ view.user.name : "Vista del
                    sistema"
                    }}
                    <div *ngIf="view.updatedBy?.name">
                      {{view.updatedBy?.name ? 'Últ. Modificación: '+view.updatedBy.name:""}}
                      {{view.updated_at | date: '(dd/MM/yyyy HH:mm)':'GMT'}} {{view.updated_at ? '' : ''}}
                    </div>
                  </small>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <br />
      <div
        *ngIf="(view.id && view.user_id == created_by && personalize_interface) || (view.user_id && views_superadmin) || (views_superadmin && isTemplate)">
        <label><small>¿Desea configurar la existente?, modifíquela</small></label>
        <br />
        <a class="p-button p-mt-2" *ngIf="personalize_interface" (click)="editView(false)">Modificar vista</a>
      </div>
      <div
        *ngIf="!((view.id && view.user_id == created_by && personalize_interface) || (view.user_id && views_superadmin) || (views_superadmin && isTemplate))">
        <label><small><i class="pi pi-exclamation-triangle"></i>Tú no puedes modificar esta vista.</small></label>
      </div>
      <br />
      <label *ngIf="personalize_interface || views_superadmin"><small>¿Quieres crear una nueva?</small></label>
      <br />
      <a class="p-button p-mt-2" *ngIf="personalize_interface" (click)="newView()">Añadir nueva vista</a>
    </ng-template>
  </p-overlayPanel>
  <a class="no-mobile" (click)="opToggle(op, $event)"
    *ngIf="!showConfigOptions && personalized_views_write && personalize_interface" pTooltip="Configurar"
    tooltipPosition="top">
    <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
  </a>
</div>

<div class="view">
  <div class="p-grid" *ngIf="showConfigOptions">
    <div class="p-col-12">
      <p-card styleClass="p-mb-3 showConfigOptions">
        <ng-template pTemplate="header">
          <div class="p-card-title" style="display:flex; align-items: center">
            <i class="fas fa-cog fa-2x"></i>
            <div style="margin-left: 10px;">
              Has activado el modo <i>Configuración vista</i>, personaliza la página como más te interese.
              <small>Recuerda que puedes editar cada componente utilizando los iconos de la parte superior derecha
              </small>
            </div>
          </div>
        </ng-template>
        <div class="p-grid">
          <div class="p-col-2 p-field">
            <label for="name">Nombre</label>
            <input name="name" type="text" pInputText [required]="true" [(ngModel)]="view.name" />
          </div>
          <div class="p-col-2 p-field" *ngIf="view.id > 1000000">
            <label for="to">¿Quién podrá hacer uso de esta vista?</label>
            <p-dropdown name="to" [required]="true" [options]="optionsMetadataTo" optionLabel="label"
              optionValue="value" appendTo="body" [(ngModel)]="view.metadata.to"></p-dropdown>
          </div>
          <div class="p-col-4 p-field" *ngIf="view.id > 1000000">
            <label for="default" *ngIf="view.metadata?.to!='onlyme'"> Convertir vista en la de por defecto</label>
            <p-checkbox id="default" name="default" *ngIf="view.metadata?.to!='onlyme'"
              [(ngModel)]="view.metadata.default" [binary]="true"></p-checkbox>
          </div>
          <div class="p-field p-col-2 p-mb-0 p-pb-0">
            <label>Layout</label>
            <p-dropdown name="view.configuration.layout" [(ngModel)]="view.configuration.layout"
              [options]="allowedLayouts" optionValue="code" optionLabel="name" placeholder="Seleccione" appendTo="body"
              (onChange)="onLayoutChange($event)">
            </p-dropdown>
          </div>

        </div>
        <div class="p-field floatRight">

          <a *ngIf="showConfigOptions && view.id && view.id > 1000000" (click)="delete()"
            class="p-button-danger p-button-link p-mr-2 p-button p-component p-ripple" pTooltip="Borrar vista"
            tooltipPosition="top">
            <!--<fa-icon [icon]="['far','trash-alt']"></fa-icon>-->Borrar
          </a>
          <a *ngIf="showConfigOptions && view.configuration?.allowedComponents" (click)="addComponent()"
            class="p-button" pTooltip="Añadir componente" tooltipPosition="top">
            Añadir componente
            <!--<fa-icon [icon]="['fas','plus-circle']"></fa-icon>-->
          </a>
          <a *ngIf="showConfigOptions" (click)="cancel()" pTooltip="Cancelar" tooltipPosition="top"
            class="p-button-link p-button-secondary p-ml-2 p-button ">
            <!--<fa-icon [icon]="['far','times-circle']"></fa-icon>-->Cancelar
          </a>
          <a *ngIf="showConfigOptions" (click)="save()" pTooltip="Guardar" tooltipPosition="top" class="p-button">
            <!--<fa-icon [icon]="['fas','save']"></fa-icon>-->Guardar
          </a>
        </div>
      </p-card>
    </div>
  </div>

  <div class="p-grid {{showConfigOptions?'configuration-mode':''}}" cdkDropListGroup>
    <div *ngFor="let col of layout" class="{{col.class}} layout-col" cdkDropList [cdkDropListData]="col.components"
      (cdkDropListDropped)="drop($event, col)">
      <div class="p-grid">
        <div *ngFor="let component of col.components ; let i = index"
          class="view-component {{showConfigOptions?'view-component-configurable':''}} {{component.class}}" cdkDrag
          [ngStyle]="{'display': this.componentService.isVisible(component,model) ? 'inline' : 'none' }"
          [cdkDragDisabled]="!this.showConfigOptions">
          <div *ngIf="showConfigOptions || componentService.isVisible(component, model)">
            <app-view-component-form *ngIf="component.template=='form'" #form [form]="viewForm" [component]="component"
              [index]="i" [model]="model" [config]="config" [showConfigOptions]="showConfigOptions"
              (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <!-- aqui no tiene sentido, solo arriba
              <a toolbarStart (click)="showComponentConfigOP($event, component)" class="internal-action">
                <fa-icon [icon]="['fas', 'cogs']"></fa-icon>
              </a>
              -->
              <a toolbarStart (click)="opToggleTitle(op2, $event, component)" pTooltip="Opciones" tooltipPosition="top"
                class="internal-action">
                <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
              </a>

              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>

            </app-view-component-form>

            <app-view-component-table *ngIf="component.template=='table'" #table [view]="view" [component]="component"
              [index]="i" [model]="model" [config]="config" [showConfigOptions]="showConfigOptions"
              (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <!-- aqui no tiene sentido, solo arriba
    <a toolbarStart (click)="showComponentConfigOP($event, component)" class="internal-action">
      <fa-icon [icon]="['fas', 'cogs']"></fa-icon>
    </a>
  -->
              <a toolbarStart (click)="opToggleTitle(op2, $event, component)" class="internal-action"
                pTooltip="Cambiar nombre" tooltipPosition="top">
                <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
              </a>
              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>

            </app-view-component-table>

            <app-view-component-card *ngIf="component.template=='card'" #card [component]="component" [index]="i"
              [model]="model" [showConfigOptions]="showConfigOptions" (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <!-- aqui no tiene sentido, solo arriba
    <a toolbarStart (click)="showComponentConfigOP($event, component)" class="internal-action">
      <fa-icon [icon]="['fas', 'cogs']"></fa-icon>
    </a>
    -->
              <a toolbarStart (click)="opToggleTitle(op2, $event, component)" class="internal-action"
                pTooltip="Cambiar nombre" tooltipPosition="top">
                <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
              </a>
              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>

            </app-view-component-card>

            <app-view-component-gallery *ngIf="component.template=='gallery'" #gallery [component]="component"
              [index]="i" [model]="model" [showConfigOptions]="showConfigOptions" (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <!-- aqui no tiene sentido, solo arriba
                <a toolbarStart (click)="showComponentConfigOP($event, component)" class="internal-action">
                  <fa-icon [icon]="['fas', 'cogs']"></fa-icon>
                </a>
                -->
              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>
            </app-view-component-gallery>

            <app-view-component-files *ngIf="component.template=='files'" #file [component]="component" [index]="i"
              [model]="model" [showConfigOptions]="showConfigOptions" (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <!-- aqui no tiene sentido, solo arriba
                <a toolbarStart (click)="showComponentConfigOP($event, component)" class="internal-action">
                  <fa-icon [icon]="['fas', 'cogs']"></fa-icon>
                </a>
                -->
              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>
            </app-view-component-files>

            <app-view-component-custom *ngIf="component.template=='custom'" #custom [component]="component" [index]="i"
              [model]="model" [showConfigOptions]="showConfigOptions" (onEvent)="onComponentEvent($event)">
              <a toolbarStart *ngIf="view.configuration?.allowedComponents">
                <fa-icon [icon]="['fas', 'trash-alt']" class="color-danger"
                  (click)="removeComponent(col, component, i)"></fa-icon>
              </a>
              <a toolbarStart (click)="opToggleTitle(op2, $event, component)" pTooltip="Cambiar nombre"
                tooltipPosition="top">
                <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
              </a>
              <a toolbarEnd cdkDragHandle>
                <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
              </a>
            </app-view-component-custom>

          </div>
        </div>
        <div *ngIf="showConfigOptions && col.components.length==0" class="placeholder">
          Arrastra aquí tu componente
        </div>
      </div>
    </div>
  </div>

</div>



<p-overlayPanel appendTo="body" #op2>
  <ng-template pTemplate>
    <div class="p-field">
      <label>Título</label>
      <div class="p-inputgroup">
        <input pInputText [(ngModel)]="component.title" />
      </div>
    </div>
    <div class="p-field" *ngIf="component.template=='table'">
      <p-checkbox [(ngModel)]="component.allow_export_xls" [binary]="true" label="Exportar a excel"></p-checkbox>
    </div>
    <div class="p-field" *ngIf="component.template=='table'">
      <p-checkbox [(ngModel)]="component.show_header" [binary]="true" label="Mostrar cabecera"></p-checkbox>
    </div>
    <div class="p-field" *ngIf="component.template=='form'">
      <p-checkbox [(ngModel)]="component.show_tracking" [binary]="true" label="Mostrar tracking"></p-checkbox>
    </div>
    <div class="p-field p-d-flex p-jc-center" *ngIf="component.template=='table'">
      <button pButton type="button" (click)="tableColumnsAdjust()">Ajuste automático</button>
    </div>
  </ng-template>
</p-overlayPanel>